import {
	Modal,
	ModalContent,
	ModalHeading,
	Paragraph,
	Tabs,
} from '@audio-network/componentlibrary'
import { Trans, useTranslation } from 'next-i18next'
import React, { useRef } from 'react'

import useProjectStore from '@/stores/projectStore'

import AddToProjectsExistingForm from './AddToProjectForms/AddToProjectsExistingForm'
import AddToProjectsNewForm from './AddToProjectForms/AddToProjectsNewForm'
import * as Styled from './AddToProjectsModal.styles'

type Props = {
	id: string
	tracks: Track[]
	source: string
	onSuccess?: () => void
}

export default function AddToProjectsModal({
	id,
	onSuccess,
	tracks,
	source,
}: Props): JSX.Element {
	const addToProjectModalRef = useRef(null)
	const projects = useProjectStore((state) => state.projects)
	const { t } = useTranslation(['addtoproject'])

	const TrackInfoHelper = (): JSX.Element => {
		let trackInfo
		if (tracks?.length === 1) {
			trackInfo = tracks[0].title
		} else {
			trackInfo = t('tracks-info', { tracksLength: tracks?.length })
		}

		return (
			<Paragraph data-testid="trackInfo">
				<Trans components={{ bold: <Styled.TrackInfoStrong /> }}>
					{t('add-message', { trackInfo: trackInfo })}
				</Trans>
			</Paragraph>
		)
	}

	if (!tracks) {
		return null
	}

	const addToProjectModalHeadingId = `add-to-project-modal-heading-${id}`

	return (
		<Modal
			aria-labelledby={addToProjectModalHeadingId}
			id={id}
			ref={addToProjectModalRef}
		>
			<ModalHeading id={addToProjectModalHeadingId}>{t('title')}</ModalHeading>

			<ModalContent>
				<div>
					<TrackInfoHelper />
					<Tabs
						tabs={
							projects?.length > 0
								? [
										{
											title: t('existing-project'),
											content: (
												<AddToProjectsExistingForm
													tracks={tracks}
													onClose={() => {
														addToProjectModalRef.current?.close()
														onSuccess && onSuccess()
													}}
													projects={projects}
													source={source}
												/>
											),
										},
										{
											title: t('new-project'),
											content: (
												<AddToProjectsNewForm
													tracks={tracks}
													onClose={() => {
														addToProjectModalRef.current?.close()
														onSuccess && onSuccess()
													}}
													source={source}
												/>
											),
										},
								  ]
								: [
										{
											title: t('new-project'),
											content: (
												<AddToProjectsNewForm
													tracks={tracks}
													onClose={() => {
														addToProjectModalRef.current?.close()
														onSuccess && onSuccess()
													}}
													source={source}
												/>
											),
										},
								  ]
						}
					/>
				</div>
			</ModalContent>
		</Modal>
	)
}
